import { render, staticRenderFns } from "./PublicView.vue?vue&type=template&id=cd6985ae&"
import script from "./PublicView.vue?vue&type=script&lang=ts&"
export * from "./PublicView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports